"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hidden = hidden;
exports.visible = visible;
// =============================================================================
// VISIBILITY (Tools)
// =============================================================================
// For hiding (and showing, if necessary) HTML while retaining accessibility for
// screen readers.
// -----------------------------------------------------------------------------
function hidden() {
    return "\n    border: 0!important;\n    clip: rect(1px 1px 1px 1px)!important;\n    height: 1px!important;\n    margin: -1px!important;\n    overflow: hidden!important;\n    padding: 0!important;\n    position: absolute!important;\n    width: 1px!important;\n  ";
}
function visible() {
    return "\n    clip: auto!important;\n    height: auto!important;\n    margin: inherit!important;\n    overflow: auto!important;\n    position: inherit!important;\n    width: auto!important;\n  ";
}
//# sourceMappingURL=visiblity.js.map